import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, switchMap } from "rxjs";
import { ApiResponse } from "src/app/shared/models/api-response.interface";
import { environment } from "src/environments/environment";
import {
  PersonalDashboardResponse,
  PersonalResponse,
  UpdateEndUserDto,
} from "../models/personal-dashboard";

@Injectable({
  providedIn: "root",
})
export class PersonalDashboardServiceService {
  apiUrl!: string;
  apiV!: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = environment.apiURL;
    this.apiV = environment.version;
  }

  getPersonalDashboardData(): Observable<
    ApiResponse<PersonalDashboardResponse>
  > {
    const url = this.apiUrl + `/api/${this.apiV}/Users/GetDashboardData`;
    return this.httpClient.get<ApiResponse<PersonalDashboardResponse>>(url);
  }

  getPersonalData(id: string): Observable<ApiResponse<PersonalResponse>> {
    const url = this.apiUrl + `/api/${this.apiV}/Users/${id}`;
    return this.httpClient.get<any>(url).pipe(
      map((res) => {
        if (res && typeof res.success === 'boolean') {
          return res;
        }
        return {
          success: true,
          data: res,
          statusCode: 200,
          message: null,
          errors: []
        } as ApiResponse<PersonalResponse>;
      })
    );
  }

  updatePersonalData(
    id: string,
    data: UpdateEndUserDto
  ): Observable<ApiResponse<PersonalResponse>> {
    const url = this.apiUrl + `/api/${this.apiV}/Users/${id}`;

    const formData = new FormData();

    // Helper: append even empty string to express "null intent"; avoid undefined
    const appendField = (key: string, value: any) => {
      if (value === null || value === undefined) {
        formData.append(key, "");
      } else {
        formData.append(key, value);
      }
    };

    appendField("id", id || data.id || "");
    appendField("firstName", data.firstName ?? "");
    appendField("lastName", data.lastName ?? "");
    appendField("userName", data.userName ?? "");
    appendField("email", data.email ?? "");
    appendField("phone", data.phone ?? "");
    appendField("streetAddress", data.streetAddress ?? "");
    appendField("province", data.province ?? "");
    appendField("ward", data.ward ?? "");
    appendField("birthdate", data.birthdate ?? "");
    appendField("registrationDate", data.registrationDate ?? "");
    appendField("lastLogin", data.lastLogin ?? "");

    appendField("avatarUrl", data.avatarUrl ?? "");

    if (data.avatarImage) {
      if (
        typeof data.avatarImage === "string" &&
        data.avatarImage.startsWith("data:")
      ) {
        try {
          const blob = this.base64DataUrlToBlob(data.avatarImage);
          formData.append("avatarImage", blob, "avatar.png");
        } catch {
          // fallback append raw string
          formData.append("avatarImage", data.avatarImage);
        }
      } else {
        formData.append("avatarImage", data.avatarImage as any);
      }
    } else {
      // vẫn append rỗng để backend có thể null hoá nếu cần
      formData.append("avatarImage", "");
    }

    return this.httpClient
      .put<ApiResponse<PersonalResponse>>(url, formData)
      .pipe(
        map((res) => {
          return {
            statusCode: (res as any)?.statusCode ?? 200,
            message: (res as any)?.message ?? null,
            data: res?.data ?? null,
            errors: (res as any)?.errors ?? [],
            success: !!res?.success,
            errorMessage: (res as any)?.errorMessage ?? null,
          } as ApiResponse<PersonalResponse>;
        })
      );
  }

  private base64DataUrlToBlob(dataUrl: string): Blob {
    const parts = dataUrl.split(",");
    const meta = parts[0];
    const base64 = parts[1];
    const mimeMatch = /data:(.*);base64/.exec(meta);
    const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mime });
  }

 
}
